<script setup>
import { computed, useAttrs } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, null],
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

defineOptions({
  inheritAttrs: false,
});

const attrs = useAttrs();

const value = computed({
  get: () => props.modelValue,
  set: newValue => emit('update:modelValue', newValue),
});

const selectAttrs = computed(() => {
  const { class: _className, ...rest } = attrs;
  return rest;
});

const containerClasses = computed(() => {
  const base = 'relative';
  const external = attrs.class ? String(attrs.class) : '';
  return [base, external].filter(Boolean).join(' ');
});
</script>

<template>
  <div :class="containerClasses">
    <select
      v-model="value"
      v-bind="selectAttrs"
      class="w-full appearance-none rounded-xl border border-n-weak/70 bg-n-solid-1 px-3 pr-10 py-2 text-sm font-medium text-n-slate-12 shadow-sm outline-none transition focus:border-n-strong focus:ring-2 focus:ring-n-strong/20 dark:border-white/40 dark:bg-n-solid-2 dark:text-white dark:focus:border-n-strong dark:focus:ring-n-strong/25"
    >
      <slot />
    </select>
    <span
      class="pointer-events-none absolute inset-y-0 right-3 flex items-center text-n-slate-9"
    >
      <span class="i-lucide-chevron-down size-4" />
    </span>
  </div>
</template>
